import * as React from "react";

import PeopleLivingIn from './PeopleLivingIn'
import SizeOf from './SizeOf'
import H2 from 'src/components/general/headings/H2';
import PeopleEarnIn from './PeopleEarnIn'

const AreaSection = () => (
  <section className="py-4 dishblue-bg text-white">
    <div className="container">
      <div className="row my-8">
      <H2>What does my council area look like?</H2>
      </div>
      <div className="row my-16">
        <PeopleLivingIn />
      </div>
      <div className="row my-16">
        <SizeOf />
      </div>
      <div className="row my-16">
        <PeopleEarnIn />
      </div>
    </div>
  </section>
);

export default AreaSection;



// WEBPACK FOOTER //
// ./src/components/report/councilArea/index.tsx